/**
 * Options for the Response Status dropdown in the Calling Summary form.
 *
 * On-file statuses use the STP title-case spelling RPA writes to
 * `response_status` (`Approval on File` / `Denial on File`) so a saved summary
 * matches the worklist badge and Response Status filter. The other four values
 * already share one spelling across enums.
 */

import { CmmResponseStatus } from "../enums/cmmResponseStatus";
import { CmmStpStatus } from "../enums/cmmStpStatus";

export const CALLING_RESPONSE_STATUS_OPTIONS = [
  { id: CmmResponseStatus.APPROVED, text: "Approved" },
  { id: CmmResponseStatus.AUTH_NOT_REQUIRED, text: "Auth Not Required" },
  { id: CmmResponseStatus.DENIED, text: "Denied" },
  { id: CmmStpStatus.APPROVAL_ON_FILE, text: "Approval on File" },
  { id: CmmStpStatus.DENIAL_ON_FILE, text: "Denial on File" },
  { id: CmmResponseStatus.PENDING, text: "Pending" },
  { id: CmmResponseStatus.SEND_TO_CLIENT, text: "Send To Client" },
];
